// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import React, { FC, useState } from "react";

import { StyledProp } from "@insite/mobius/utilities/InjectableCss";

/* Starter Custom Code - Start */
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
/* Starter Custom Code - End */

export interface CardListStyles {
    gridContainer?: GridContainerProps;
}

export const cardListStyles: CardListStyles = {
    gridContainer: {
        gap: 0,
    },
};

const CardList: FC<{
    extendedStyles?: CardListStyles;
    css?: StyledProp;
    // Starter Custom Code
    overridedStyles?: CardListStyles;
}> = ({ extendedStyles, children, overridedStyles, ...otherProps /* Starter Custom Code */ }) => {
    const styles = useExpandProps(cardListStyles, extendedStyles, overridedStyles); // Starter Custom Code

    return (
        <GridContainer {...styles.gridContainer} {...otherProps}>
            {children}
        </GridContainer>
    );
};

export default CardList;
